module.exports = __webpack_public_path__ + "img/Zi_Huang@2x.743ca566.png";